const WORKSPACE_PAGE_NAME_PATTERN = /^\/workspace\/[^/]+\/([^/]+)(?:\/|$)/;

export function getPageName(pathname: string): string | null {
  const matchedPageName = pathname.match(WORKSPACE_PAGE_NAME_PATTERN)?.[1];

  return matchedPageName ?? null;
}
